import Env from '../base/env';
import { module } from 'modujs';
import { getCoords, lerp } from '../utils/utilities';
import gsap from 'gsap';
import { SplitText } from '../vendor/gsap-esm/SplitText';
import { onRAF } from '../utils/onRaf.js';
gsap.registerPlugin(SplitText);

export default class extends module {
  constructor(m) {
    super(m);
    this.events = {
      mouseenter: {
        trigger: 'hoverIn',
        linklist: 'hoverList',
      },
      mouseleave: {
        linklist: 'leaveList',
      },
      mousemove: 'follow',
    };
  }

  init() {
    this.Z_INDEX = 1;
    this.DOM = {
      view: this.el,
    };
    this.FX = {
      splits: [],
    };
    this.hoverTriggerFx();
    this.setupHoverFx();

    this.currentPosition = { x: 0, y: 0 };
    this.newPosition = { x: 0, y: 0 };
    this.clipSetup();
    this.enableBG(0);
    this.unregisterRAF = onRAF(() => this.watch());
  }

  clipSetup() {
    for (let bg of this.$('background')) {
      gsap.set(bg, { clipPath: 'polygon(0 0, 100% 0%, 100% 0, 0 0)' });
    }
  }

  disableBG(index) {
    const img = this.$('background')[index];
    const trigger = this.$('trigger')[index];
    trigger.classList.remove('is-active');
    gsap.delayedCall(0.4, () => {
      gsap.set(img, { clipPath: 'polygon(0 0, 100% 0%, 100% 0, 0 0)' });
    });
    gsap.delayedCall(0.15, () => {
      img.classList.remove('is-active');
    });
  }

  enableBG(index) {
    this.Z_INDEX++;
    const img = this.$('background')[index];
    const trigger = this.$('trigger')[index];
    img.classList.add('is-active');
    trigger.classList.add('is-active');
    gsap.to(img, {
      clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)',
      duration: 0.4,
      ease: 'cubic.inOut',
    });
    img.style.zIndex = this.Z_INDEX;
  }

  hoverIn(e) {
    const index = e.currentTarget.dataset.index * 1;
    for (let [i, el] of this.$('background').entries()) {
      if (i != index) {
        this.disableBG(i);
      }
    }
    this.enableBG(e.currentTarget.dataset.index);
  }

  hoverList() {
    this.DOM.view.classList.add('is-hovered');
  }

  leaveList() {
    this.DOM.view.classList.remove('is-hovered');
  }

  hoverTriggerFx() {
    this.$('trigger').forEach((li) => {
      const mySplit = new SplitText(li.querySelectorAll('span')[1], {
        type: 'chars',
      });
      const myTL = gsap.timeline({ paused: true });

      for (let [i, char] of mySplit.chars.entries()) {
        myTL.add(
          [
            gsap.set(mySplit.chars, {
              color: '#fff',
            }),
          ],
          '+=.06'
        );
        if (typeof mySplit.chars[i] != 'undefined') {
          myTL.add(
            [
              gsap.set(mySplit.chars[i], {
                color: '#000',
              }),
            ],
            '>'
          );
        }
        if (typeof mySplit.chars[i + 1] != 'undefined') {
          myTL.add(
            [
              gsap.set(mySplit.chars[i + 1], {
                color: '#000',
              }),
            ],
            '>'
          );
        }
        if (typeof mySplit.chars[i + 2] != 'undefined') {
          myTL.add(
            [
              gsap.set(mySplit.chars[i + 2], {
                color: '#000',
              }),
            ],
            '>'
          );
        }
      }
      myTL.add([gsap.set(mySplit.chars, { color: '#fff' })]);
      myTL.add(
        [
          gsap.fromTo(
            mySplit.chars,
            { color: '#fff' },
            {
              color: '#000',
              duration: 0.001,
              immediateRender: false,
              stagger: 0.02,
            }
          ),
        ],
        '+=.05'
      );
      if (Env.mobileCSS == false) {
        li.addEventListener('mouseenter', function () {
          myTL.restart();
        });
      }

      this.FX.splits.push(mySplit);
    });
  }

  follow(e) {
    const coords = getCoords(this.DOM.view);
    const posY = e.clientY - coords.y;
    const setHeight = Math.round(coords.height / 2);
    this.currentPosition.y = posY / setHeight - 1;
  }

  setupHoverFx() {
    for (let split of this.FX.splits) {
      gsap.set(split.chars, { color: '#000' });
    }
  }

  watch() {
    this.newPosition.y = lerp(this.currentPosition.y, this.newPosition.y, 0.9);

    gsap.set(this.$('visuals'), { y: this.newPosition.y * 25 });
  }

  destroy() {
    this.unregisterRAF();
  }
}
